export default __webpack_public_path__ + "static/realLeaf2-bbd5e77a12e7f74ae43f474425525744.png";